
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProgressSpinner from 'primevue/progressspinner';
import ProgressBar from 'primevue/progressbar';

export default defineComponent({
  name: 'HistoryRestoreLoader',

  components: {
    ProgressSpinner,
    ProgressBar,
  },

  props: {
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    actionDetail: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const { t } = useI18n();

    const progressPercent = computed(() => {
      if (props.total === 0) return 0;
      return Math.round((props.current / props.total) * 100);
    });

    return {
      t,
      progressPercent,
    };
  },
});
